/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";
import { IOfferSchema } from '../../entities/offer/OfferSchema';

export type TPublishOfferModel = IModel<
  IPublishOfferRequest,
  TPublishOfferResponse
>;

export interface IPublishOfferRequest extends IOfferSchema {}

export type TPublishOfferResponse =
  | IPublishOfferResponse200
  | IPublishOfferResponse400;

export interface IPublishOfferResponse200
  extends IModelResponse<IPublishOfferSuccessResponse> {
  statusCode: 200;
}

export interface IPublishOfferResponse400
  extends IModelResponse<IPublishOfferFailResponse> {
  statusCode: 400;
}

export interface IPublishOfferSuccessResponse {
  /** Ошибки **/
  errors?: IPublishOfferResponseErrors | null;
  /** ID объявления в Realty **/
  id: number;
  /** URL для редиректа после публикации **/
  redirectUrl?: string | null;
  /** Статус публикации **/
  status: EStatus;
}

export interface IPublishOfferFailResponse {
  status: EStatus;
  data: IPublishOfferFailResponseData;
}

export interface IPublishOfferFailResponseData {
  errors: IPublishOfferResponseErrors;
}

export interface IPublishOfferResponseErrors {
  [key: string]: Array<IPublishOfferResponseError>;
}
export interface IPublishOfferResponseError {
  message: string;
  code: string;
  messageRu: string;
}

export type TResponses = IPublishOfferSuccessResponse | IPublishOfferFailResponse;

export enum EStatus {
  /** Успешно опубликовано **/
  Success = "success",
  /** Идентификация в процессе **/
  UserIdentificationInProgress = "userIdentificationInProgress",
  /** Требуется идентификация **/
  UserIdentificationRequired = "userIdentificationRequired",
  /** Ожидает публикации **/
  WaitForPublish = "waitForPublish"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IPublishOfferSuccessResponse): TResponse200;
  400(response: IPublishOfferFailResponse): TResponse400;
}
